const purchase = {
  // 供应商列表
  code: "供应商编码",
  name: "供应商名称",
  shortName: "供应商简称",
  country: "国籍/区域",
  address: "地址",
  zipCode: "邮政编码",
  email: "Email地址",
  contact: "联系人",
  phone: "电话",
  fax: "传真",
  mobile: "手机",
  account1: "开户银行1",
  bank1: "银行账号1",
  swiftCode1: "银行编码1",
  account2: "开户银行2",
  bank2: "银行账号2",
  swiftCode2: "银行编码2",
  creditLevel: "信用等级",
  creditLine: "信用额度",
  depositRate: "定金比例(%)",
  tradeTerm: "贸易条款",
  payMethod: "付款方式",
  affiliates: "关联公司",
  org: "分管部门",
  taxRate: "税率（%）",
  taxRate1: "税率",
  billingDays: "帐期(天)",
  principal: "委托方",
  relatedDocuments: "相关资料(合同/营业执照/开票资料)",
  price: "价格",

  // 供应商表单
  plCode: "请输入供应商编码",
  plName: "请输入供应商名称",
  plShortName: "请输入供应商简称",
  plAddress: "请输入供应商地址",
  plZipCode: "请输入供应商邮政编码",
  plEmail: "请输入供应商Email地址",
  plContact: "请输入联系人",
  plPhone: "请输入供应商电话",
  plFax: "请输入供应商传真",
  plMobile: "请输入供应商手机号",
  plBank1: "请输入银行账号1",
  plAccount1: "请输入开户银行1",
  plSwiftCode1: "请输入银行编码1",
  plBank2: "请输入银行账号2",
  plAccount2: "请输入开户银行2",
  plSwiftCode2: "请输入银行编码2",
  plCreditLine: "请输入信用额度",
  plDepositRate: "请输入定金比例",
  plTradeTerms: "请选择贸易条款",
  plPaymentMethod: "请选择付款方式",
  plAffiliates: "请输入关联公司",
  plTaxRate: "请输入税率",
  plBillingDays: "请输入帐期",
  plPrincipal: "请输入委托方",
  wmsApi: "供应商API",
  plWmsApi: "请输入供应商API",

  // 供应商操作
  customerList: "供应商列表",
  addCustomer: "添加供应商",
  documents: "相关资料",

  // 供应商异常码
  codeExisted: '供应商编码已存在',
  supplierNotExisted: "供应商不存在",

  // 价格
  stPrice: '含税单价',
  priceExisted: '当前商品已有价格，无需重新添加',
  product: "商品",
  plPrice: "请输入含税单价",
  expiredAt: '过期时间',
  plExpiredAt: '请选择过期时间',
  priceExpiredAt: '有效期',
  days: '供货周期',
  plDays: '请输入供货周期',
  mpq: '最小包装',
  plMpq: '请输入最小包装',
  remark: '备注',
  plRemark: "请输入备注",
  plRemarkMax: '内容不得超过{{ length }}',
  priceIndex: '商品价格{{ index }}',
  priceCount: '数量',
  plPriceCountIndex: '阶梯价{{ index }}的数量是必填项',
  plPriceCount: '请输入阶梯数量',
  plPriceItemIndex: '阶梯价{{ index }}的含税单价是必填项',
  plPriceIndex: '请输入对应的含税单价',
  plPriceAdd: '添加阶梯价',

  purchaseType: '采购类型',
  plPurchaseType: '请选择采购类型',
  plSupplier: '请选择供应商',
  plProduct: '请选择商品与价格',
  plProductPrice: '请选择商品与价格，输入名称可进行搜索',
  supplier: '供应商信息',
  productCount: '商品数量',
  plProductCount: '请输入商品数量',
  scheduledOrderTime: '预计下单时间',
  plScheduledOrderTime: '请选择预计下单时间',
  deliveryDeadline: '要求送货时间',
  plDeliveryDeadline: '请选择要求送货时间',
  estimateArrivalAt: '预计送达时间',
  plEstimateArrivalAt: '请选择预计送达时间',
  deliveredQuantity: '累计送达数量',
  plDeliveredQuantity: '请选择已送达数量',
  productDesc: '商品单品备注',
  plProductDesc: '请输入商品单品备注',
  orderDesc: '订单备注',
  plOrderDesc: '请输入订单备注',
  productInfo: '商品信息',
  orderNotExisted: "采购订单不存在",
  purchased: '已下单',
  notPurchase: '未下单',
  noPurOrder: '待采购',
  orderTime: '下单时间',
  supplierInfo: '供应商信息',
  orderList: '采购订单列表',
  addPrice: "添加商品价格",
  bySearchPrice: "通过存货编码、存货名称、产品型号进行搜索",
  bySearchSupplier: '通过供应商编码、供应商名称、供应商简称、地址进行搜索',

  orderNumber: '订单编号',
  purNo: '采购单号',
  orderState: '下单状态',
  type: '采购类型',
  count: '采购数量',
  amount: '未税总价',
  rateAmount: '含税总价',
  priceDetail: "价格信息",
  printedTip: "该订单已打印哦",
  printSelectTip: "请至少选择一条数据进行打印",
  orderNum: "订单编号",
  orderTime1: "订单日期",
  currency: "结算币种",
  demandNum: "需求单号",
  quantity: "数量",
  priceTax: "含税单价",
  totalPrice: "价税合计",
  deliveryTime: "交货日期",
  total: "合计",
  purchase: "采购",
  review: "审核",
  signature: "厂商回签",
  createTime: "创建日期",
  reviewTime: "审核日期",
  sigTime: "回签日期",
  notSelect: "无法选中",
  selectPurError: "请选择供应商相同的采购订单",
  selectCurrencyError: "请选择结算币种相同的采购订单",
  selectPayMethodError: "请选择付款方式相同的采购订单",
  addOrder: "添加订单",
  searchCode: "通过存货编码进行搜索",
  supplierPrint: '供应商',
  currencyPoint: '结算币种：',
  purchaseList: '采购订单',
  pageIndex: '第 {{ index }} 页 / 共 {{ total }} 页',
  printReq: '生成采购文件',
  printRejectedFiltered: "已过滤已拒绝订单",
  printRejectedFilteredDesc: "已自动过滤 {{rejectedCount}} 条已拒绝订单，剩余 {{validCount}} 条继续生成采购文件。",
  printRejectedBlocked: "无法生成采购文件",
  printRejectedBlockedDesc: "所选订单均为已拒绝订单，请调整选择后再试。",
  downloadFile: '点击可以下载已经生成好的采购文件',
  successFile: '成功生成采购文件，正在唤起本地打印~',
  placeOrder: "下单",
  completed: "完成",
  plPlaceOrder: "你确定该笔订单已下单吗？",
  plPlaceOrders: "你确定这些订单已下单吗？",
  plOrderOk: "你确定该笔订单已完结吗？",
  plSeSupplier: "选择供应商",
  plPlacePrice: "选择下单价格",
  search: "搜索",
  clearFilters: "清空筛选",

  materialCode: "物料编码",
  materialName: "物料名称",
  materialModel: "物料型号",
  purCount: "采购数量",
  supplierTime: "齐料时间",
  addPurOrder: "一键生成采购单",
  addPurOrderTip: "自动生成采购订单",
  roundMethod: "取整方式",
  roundNone: "不取整",
  roundDown: "向下取整",
  roundUp: "向上取整",
  roundNearest: "四舍五入",
  addPurSuccessTip: "一键生成采购单成功",
  addPurSuccessTipDesc: "总单数：{{all}}，生成采购单数量：{{suc}}",
  purConfirm: "采购确认",
  conPur: "确定采购",
  notPur: "暂不采购",
  purCurrency: "采购币种",
  curr: "币种",
  exchangeRateL: "汇率",
  purPrice: "价格",
  purPrice_1: "采购价",
  purPrice_2: "采购单价",
  all: "合计",
  supplierUserName: '供应商账号名称',
  supplierUser: '供应商账号',
  supplierReset: '重置密码',
  initPwd: '初始密码',
  plSupplierUser: '请输入供应商账号',
  supplierUserAdd: '添加供应商账号',
  supplierUserSearch: '通过账号进行搜索',
  resetPwd: '密码将重置为：{{ newPwd }}',
  resetPwdOk: '重置密码成功',
  editPwdError: '密码修改失败',
  userList: '供应商账户列表',
  accounts: '供应商账户',
  ceil: "小计",
  addNoPurSuccess: "没有新的采购订单生成",
  printState: '打印状态',
  unPrt: '未打印',
  supplierBatchNo: '供应商批次号',
  batchDeliveryNote: '批量送货单',
  batchCompletedProduction: '批量完结',
  batchCompleteSummary: '已选择 {{selected}} 条',
  batchCompleteNoAvailable: '当前选中项中没有可完结的订单',
  inventoryCode: '存货编码',
  supplierCode: '供应商编码',
  supplierName: '供应商名称',
  purchaseQuantity: '采购数量',
  supplierLot: '供应商批次号',
  plSupplierLot: '请输入供应商批次号',
  pleaseSelect: '请至少选择一条数据',
  pleaseSelectDeliveryTime: '请选择送货时间',
  pleaseInputDeliveryCount: '请输入送货数量和lot',
  leastOneMoreZero: '至少有一条送货数量大于0且lot必填',
  pleaseInputSupplierLot: '请输入供应商批次号',
  batchDeliverySuccess: '批量送货单创建成功',
  plSupplierBatchNo: '请输入供应商批次号',
  maxDeliveryQty: '可送货数',
  noDeliveryData: '没有可继续生成采购单的数据',
  deliveryDate: '送货时间',
  selectDeliveryDate: '请选择送货时间',
  prt: '已打印',
  isPrted: '是否已打印',
  payMethodPoint: "收付款协议名称：",
  printCode: '料号',
  printName: '品名',
  printModel: '规格型号',
  spec: '规格',
  printUnit: '单位',
  printNum: '数量',
  printSPrice: '含税单价',
  printPrce: '含税金额',
  del: '作废',
  delTips: '作废提示',
  delContent: '你确定要作废这个数据吗？作废后数据不可恢复！',

  state: '状态',
  acceptType: '已接受',
  rejectType: '已拒绝',
  pend: '待处理',
  rejectDetail: '退回详情',
  accept: '接受',
  reject: '拒绝',

  rejectDate: '退回时间',
  operationPerson: '操作人',
  rejectInformate: '退回信息',
  comfi: '确定接受采购单吗？',
  ok: '确定',
  cancel: '取消',
  rejectComfi: '确定拒绝采购单吗？',
  reOrder: '重新选择供应商',
  operate: '操作',
  priced: "该商品已存在有效报价！",
  priceManage: '报价单审批',
  selectNumOver: "最多选择10条！",
  onOk: '确定通过报价单吗？',
  onReject: '确定拒绝报价单吗？',
  payMethodName: '付款协议',
  helpAcc: '协助接受',
  sendTimePrint: '送货日期',
  mobilePrint: '联系电话',
  recver: "联系人",
  seq: "序号",
  sendNum: "送货批次号",
  outLot: "出库批次",
  sendAddress: "交货地址",
  printErr: "打印失败",
  printDeliveryNote: "打印送货单",
  phone1: "联系电话",
  orderDetail: "送货单详情",
  sendInfo: "送货信息",
  delivery: '送货单',
  deliveryNumber: '送货单号',
  deliveryStatus: '完工状态',
  updatePurchaseOrderStatus: '修改采购单状态',
  purchaseOrderStatus: '采购单状态',
  deliverable: '可送货',
  notDeliverable: '不可送货',
  inState: '到货状态',
  unArrived: '未到货',
  partialIn: '部分到货',
  allIn: '全部到货',
  // Production finish status
  pendingProduction: '待生产',
  inProduction: '生产中',
  finishedProduction: '已完工',
  completedProduction: '完结',
  confirmCompletedProduction: '确定要完结此订单吗？',
  confirmBatchCompletedProduction: '确定要批量完结这批订单吗？',
  markAsFinished: '标记为完成',
  confirmFinish: '确定要完成此项目吗？',
  complete: '完成',
  startProduction: '开始生产',
  markAsFinishedProduction: '标记为完工',
  confirmFinishProduction: '确定要将此项目标记为完工吗？',
  confirmMarkAsInProduction: '确定标记为生产中吗？',
  confirmMarkAsFinished: '确定标记为已完工吗？',
  markAsInProduction: '标记为生产中',
  selectStatus: '选择状态',
  confirmMarkAsStatus: '确定标记为<strong>{{status}}</strong>吗？',
  deliveryDatePlaceholder: '最晚送货日期',
  notInStock: '未入库',
  inStock: '已入库',
  deliveryOrders: '已生成送货单',
  goodName: '物料名称',
  goodCode: '存货编码',
  goodModel: '型号',
  preInventory: '预入库单',
  saveCodes: '保存条码',
  clearCodes: '清空条码',
  outOrder: '已生成出入库单',
  isOut: '已出库',
  notOut: '未出库',
  hasPurOrder: '已生成采购单',
  outOrderNumber: '出库单号',
  goodsExpiredAt: '物料有效期',
  plGoodsExpiredAt: '请输入物料有效期',
  year: '年',
  helpAccSuc: '已帮助该供应商接受报价。',
  helpRejSuc: '已帮助该供应商拒绝报价。',
  noReq: '无法重新选择供应商！',
  noReqDesc: '该采购订单没有问询单，因此无法重新选择供应商',
  equotationRequest: '问询单状态',

  receivingUnit: '送货单位',
  receivingAddress: '交货地址',
  deliveryProgress: '送货单进度',
  zfed: "已作废",
  mainCurPrice: "本位币金额",
  billingDay: "账期:",
  sendAdd: "送货地址：",
  unRatePrice: "未税单价",
  nilPur: "未生成",
  purState: "采购单状态",
  sendAds: "送货地址",
  sendAdsPl: "请选择送货地址",
  accer: "接收人",
  rePrt: "重新打印",
  rePrtCon: "确定重新打印么？",
  plRePrt: "请重新打印",
  onlyOneReq: "只能选择同一需求单的订单",
  multyDown: "批量下载",
  downErr: "下载失败",
  leastOne: "至少选择一条数据",
  inReturn: "已退库",
  stocked: "是否已入库",
  selectDateError: "只能选择同一送货时间的订单",
  spareRate: "备品率(%)",
  spareRate_1: "备品率",
  spareRatePl: "请输入备品率",
  spareCount: "备品数",
  spareCountPl: "请输入备品数",
  cancelReturn: "取消退库",
  reqPur: "需求清单/采购单",
  pdaPrint: "采购制单PDA打印",
  qcNum: "抽检数",
  qcNo: "不良数",
  qcOk: "检验结果",
  qc: "核准",
  pg: "品管",
  cg: "仓管",
  outPrint: "出库单打印",
  checkoutOrder: "验收单",
  normalTemplate: "正常模版",
  warehouseTemplate: "仓储模版",
  brand: "品牌",
  plBrand: "请输入品牌",
  dictCurrency: "币种",
  printSetting: "打印设置",
  otherInfo: "物料标签",
  originalBrand: "物料原厂名称",
  originalCode: "物料原厂代码",
  mpn: "原厂代码",
  plMpn: "请输入原厂代码",
  manufactureDate: "物料原厂生产周期",
  msdLevel: "物料MSD等级",
  dcc: "D/C",
  plShelfLife: "请输入保质期",
  originPlace: "产地",
  netWeight: "净重",
  grossWeight: "毛重",
  plOriginalBrand: "请输入物料原厂名称",
  plOriginalCode: "请输入物料原厂代码",
  plManufactureDate: "请输入物料原厂生产周期",
  plMsdLevel: "请输入物料MSD等级",
  plOriginPlace: "请输入产地",
  plNetWeight: "请输入净重",
  plGrossWeight: "请输入毛重",

  importSupplierPrice: '导入供应商价格',
  downloadPriceTemplate: '下载价格模版',
  importSuccess: '导入成功',
  importSuccessDesc: '成功导入 {{count}} 个物料的价格数据',
  importCompleted: '导入完成',
  importPartialDesc: '成功 {{success}} 个，失败 {{failed}} 个（{{failedList}}）',
  fileParseError: '文件解析失败，请检查文件格式',

  // 价格模版填写规范提示
  templateWarningTitle: '注意',
  templateWarningIntro: '请注意价格模版的填写规范:',
  templateWarning1: '1、可以一次性填写多个物料，请保证物料编码的准确性；',
  templateWarning2: '2、每个物料可以填写多行数据，每个物料第一行数据为基准价格数据，数量不可以填写，每个物料第二行及以后的数据为阶梯价，填写存货编码和含税单价和数量即可；',
  templateWarning3: '3、请确保结算货币（可以不区分大小写）在系统中存在；',
  templateWarning4: '4、请确保生效日期和失效日期字段值为8位数字，例如：20260309（2026年3月9日）；',
  templateWarning5: '5、如果数据填写有误可能会造成数据解析失败或者导入信息有误；',
  templateWarning6: '6、供应商编码列必填;',
  iHaveKnown: '我已知悉',

  // 确认订单提示
  confirmOrder: '确定下单？',
  confirmOrderTip: '确认下单？',
  incompleteRecipientInfo: '收货单位、收货地址、联系人、联系电话等信息未完善。',
  pleaseCompleteRecipientInfo: '请完善收货方数据',
  recipientInfoDetails: '收货单位、收货地址、联系人、联系电话',
  syncToSupplier: '同步供应商状态',

  // 供应商价格模板
  priceTemplateFileName: '供应商价格模板',
  excelHeaderInventoryCode: '存货编码',
  excelHeaderUnitPriceIncludingTax: '含税单价',
  excelHeaderMaterialValidityPeriod: '物料有效期(年)',
  excelHeaderSupplyCycle: '供货周期(天)',
  excelHeaderMinimumPackage: '最小包装',
  excelHeaderQuantity: '数量',
  excelHeaderSettlementCurrency: '结算币种',
  excelHeaderBrand: '品牌',
  excelHeaderMpn: '原厂代码',
  excelHeaderShelfLife: 'D/C',
  supplierPrice: '供应商价格',
  supplierHisPrice: '供应商历史价格',
  hisPriceExport: '历史价格导出',
  allPriceHis: '全部历史价格导出',
  generated: "已生成",

  importInbound: "导入生成送货单",
  inboundTemplate: "送货单导入模版",
  sendTime: "送货日期",
  inboundTemplateTip1: "1、送货日期必须填写八位数字，例如20260311（2026年3月11日）",
  inboundTemplateTip2: "2、数量填写该采购单的送货数量",
  inboundTemplateTip3: "3、相同采购单号和相同送货时间的记录会合并，数量相加",
  inboundTemplateTip4: "4、数据填写不合规可能会解析失败，或导入不成功！",
  inboundTemplateTip5: "5、lot列可填可不填，如果不填则系统自动生成批次",
  noData: "没有解析到数据",
  matchErr: "采购单数据匹配失败，请重试！",
  importDone: "导入执行完毕",
  succNum: "成功个数",
  importErrTip: "以下采购单需要检查数据",
  maxQuantityErr: "以下采购单总送货量超出可送货数量",
  excelCount: "总送货数量",
  purNoErr: "第{{index}}行：采购单号校验有误",
  countErr: "第{{index}}行：送货数量有误",
  preTimeErr: "第{{index}}行：送货时间有误",
  importErr: "数据匹配失败，没有数据导入",
  notPurNo: '以下采购单不存在',
  numAdds: '数量合计',
  rateNumAdds: '含税金额合计',
  ratePceAdds: '含税单价合计',
  toReturn: "待退库",
  returnQty: "退货数量",
  actualArrivalQty: "实际到货数量",
  actualArrivalTime: "实际到货时间",
  undeliveredQty: "未交货数量",
  orderNums: "送货单数量",

  importSuppOrders: "导入生成供应商送货单",
  allSendQty: "送货总数量",
  sentQty: "已送货数量",
  sendQty: "本次送货数量",
  remainQTy: "剩余送货数量",
  noSendInfo: "没有送货信息",
  fileLoss: "导入源文件丢失！",
  import: "导入模版数据",
  matchPur: "匹配采购单",
  done: "完成",
  thdCode: "MES客户编码",
  plThdCode: "请输入MES客户编码",
  batchSubmit: '批量报价',
  batchSubmitSucc: '批量报价成功',
  batchSubmitErr: '批量报价失败',
  needPriceTip: '以下数据需要手动填写价格',
  batchSubmitTip: '确定对所选择的问询单报价吗？',
  actualInboundTime: "实际入库时间",
  supplierCodeNeed: "第{{index}}行供应商编码不存在，解析失败",
  addRule: "是否添加 采购订单交易条约 ？",
  effectiveAt: "生效日期",
  expiredAtEcl: "失效日期",
  effectiveAtPl: "请选择生效日期",
  expiredAtEclPl: "请选择失效日期",
  purOrderPl: "请选择采购单",
  notApi: "该供应商没有配置供应商Api，无法进行转单！",
  swapData: "转单数据",
  swapDone: "转单完成",
  notSuppPros: "供应商系统中不存在这些商品，请去该供应商所在的系统中添加这些商品信息",
  notSaleProPrice: "供应商系统中不存在该终端客户的客户价格，请去该供应商的系统中添加这些客户价格",
  purchaseTransferSuccess: "采购单转单销售单完成",
  noRejected: "改采购单已拒绝，无法进行转单！",
  swapErr: "转单失败",
  startSwap: "开始转单",
  priceComputedTip: "商品数量或税率发生变动，需要重新计算价格",
  selectPurErrorTip: "请选择相同供应商，相同结算币种，相同付款方式的条目",
  notResolved: "该采购单不是已接受状态，无法选中",
  printedTipErr: "以下条目已打印，无法继续打印",
  downloadTip: "PDF生成完毕，是否下载?",
  pdfIng: "正在生成PDF",
  addPurchaseOrder: '添加采购单',
  addItem: '添加订单项',
  item: '订单项',
  items: '订单项',
  plCurrency: '请选择币种',
  plPayMethod: '请选择付款方式',
  ladderPrice: "阶梯价",
  ladderPriceCount: "数量",
  productType: "产品类型",
  brandName: "品牌名称",
  brandModel: "品牌型号",
};

export default purchase;
